import { z } from "zod";

export const AddEditHolidaySchema = z.object({
  holidayName: z.string().nonempty({ message: "Holiday name is required" }),
});
